import React from 'react';
import './Footer.css';
import darkcafeBeer from '../assets/images/webcafe-beer-v1.png';

const footerLinks = [
  {
    title: 'Social Media',
    links: [
      { name: 'Youtube', url: 'https://youtube.com/@Corbin_Brown' },
      { name: 'X', url: 'https://x.com' },
      { name: 'Digital Nomad', url: 'https://www.digitalnomad.com' },
    ]
  },
  {
    title: 'Investments',
    links: [
      { name: 'AI Marketplace', url: 'https://webcafesoftware.com' },
      { name: 'Bumpups', url: 'https://bumpups.com' },
      { name: 'Skool', url: 'https://skool.com' },
    ]
  },
  {
    title: 'Education',
    links: [
      { name: 'Content Catalog', url: 'https://youtube.com/@Corbin_Brown' },
      { name: 'Take This Website', url: 'https://www.youtube.com/watch?v=-tnPCI5RdNA' },
    ]
  },
  {
    title: 'Paid Promotion',
    links: [
      { name: 'Contact', url: 'https://www.webcafesoftware.com/contact' },
    ]
  }
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
         
        </div>
        <div className="footer-bottom">
          <div className="footer-logo-container">
           
            <span className="footer-company-name">Copyright @Krish's Dad :)</span>
          </div>

          <p className="footer-country">Citizen of the World</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;